import { render, staticRenderFns } from "./metodo.vue?vue&type=template&id=7c83dc96"
import script from "./metodo.vue?vue&type=script&lang=js"
export * from "./metodo.vue?vue&type=script&lang=js"
import style0 from "./metodo.vue?vue&type=style&index=0&id=7c83dc96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports